/* eslint-disable react/prop-types */
import {useContext, useState} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import Helmet from '@s-ui/react-head'
import {useMount} from '@s-ui/react-hooks'
import {useLocation, useRouter} from '@s-ui/react-router'
import Layout from '@adv-mt/mt-layout-basic'
import LayoutPageContent from '@adv-mt/mt-layout-page-content'
import ModalTransactionCancel from '@adv-mt/mt-modal-transaction-cancel'
import NavigationRequireAuth from '@adv-mt/mt-navigation-require-auth'
import IconAngleLeft from '@adv-mt/mt-svg-icons/lib/AngleLeft.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import LinkFactory from '../../../components/LinkFactory/index.js'
import {ROUTES} from '../../../config/index.js'
import TransactionTrustFooter from '../components/transactionTrustFooter.js'
import HelpText from './components/HelpText.js'
import {getInitialProps} from './getInitialProps.js'

const TransactionSellerId = ({adPrice, adTitle, pageName = '', pageTrackingData = {}, __HTTP__ = {}}) => {
  const {redirectTo} = __HTTP__

  const {domain, i18n} = useContext(Context)
  const {pathname, search, query} = useLocation()
  const {push, replace} = useRouter()
  const [showModalCancel, setShowModalCancel] = useState(false)
  const {page} = useAnalyticsTrack()

  useMount(() => {
    page(pageTrackingData)
  })

  if (redirectTo) {
    push(redirectTo)
    return <></>
  }

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const {META_ROBOTS_NO_INDEX_NO_FOLLOW} = config.get('seo')
  const helmet = {
    meta: [META_ROBOTS_NO_INDEX_NO_FOLLOW]
  }

  const handleOnModalClose = () => {
    setShowModalCancel(false)
  }

  const handleOnClickCancelCta = () => {
    setShowModalCancel(false)
  }

  const handleOnClickTopbarCta = async () => {
    setShowModalCancel(true)
  }
  const topbarCtaText = i18n.t('COMMON.CANCEL_SALE')

  const handleOnClickCta = () => {
    replace({
      pathname: ROUTES.TRANSACTION.SELLER_ID_UPLOAD_FRONT,
      query
    })
  }

  return (
    <NavigationRequireAuth currentPath={`${pathname}${search}`}>
      <Helmet {...helmet} />
      <Layout.FullWidth
        linkFactory={LinkFactory}
        footerProps={{isSimple: true}}
        topbarProps={{
          customContent: (
            <AtomButton
              color={atomButtonColors.PRIMARY}
              design={atomButtonDesigns.SOLID}
              disabled={false}
              onClick={handleOnClickTopbarCta}
              shape={atomButtonShapes.CIRCULAR}
              size={isMobile ? atomButtonSizes.SMALL : atomButtonSizes.MEDIUM}
            >
              {topbarCtaText}
            </AtomButton>
          ),
          mainNavigationItems: [],
          navButton: (
            <AtomButton
              color="primary"
              design={atomButtonDesigns.FLAT}
              leftIcon={<IconAngleLeft />}
              link
              onClick={() => window.history.back()}
              size={atomButtonSizes.LARGE}
              shape={atomButtonShapes.CIRCULAR}
            />
          ),
          showBrandIcon: true,
          showNavUserOnDesktop: false,
          showToggleNavOnMobile: false,
          ...(!isMobile && {title: `${i18n.t('COMMON.SECURE_PURCHASE_OF')} ${adTitle}`})
        }}
      >
        <Layout.Container isFullHeight isFullWidth isMarginless>
          <LayoutPageContent
            buttonsConfig={{
              primaryCta: {
                color: atomButtonColors.PRIMARY,
                design: atomButtonDesigns.SOLID,
                fullWidth: true,
                handleOnClick: handleOnClickCta,
                text: i18n.t('COMMON.CONTINUE')
              }
            }}
            footer={<TransactionTrustFooter />}
            helpBox={<HelpText />}
            stepperConfig={{
              steps: 4,
              step: 2,
              labels: ['', i18n.t('VEHICLE_TRANSACTION.SELLER_ID.STEP'), '', '']
            }}
            subtitle={i18n.t('VEHICLE_TRANSACTION.SELLER_ID.TITLE')}
          >
            {showModalCancel && (
              <ModalTransactionCancel
                onCtaClick={handleOnClickCancelCta}
                onModalClose={handleOnModalClose}
                targetPath={ROUTES.USER.MESSAGES}
                isSeller
              />
            )}
            <div className="mt-TransactionSellerId-mainContent">
              <span>
                {htmlStringToReactElement(
                  i18n.t('VEHICLE_TRANSACTION.SELLER_ID.MAIN_TEXT_PARAGRAPH_1', {
                    highlightStart: '<strong>',
                    highlightEnd: '</strong>'
                  })
                )}
              </span>
              <span>{i18n.t('VEHICLE_TRANSACTION.SELLER_ID.MAIN_TEXT_PARAGRAPH_2')}</span>
            </div>
          </LayoutPageContent>
        </Layout.Container>
      </Layout.FullWidth>
    </NavigationRequireAuth>
  )
}

TransactionSellerId.displayName = 'TransactionSellerId'
TransactionSellerId.propTypes = {}

TransactionSellerId.getInitialProps = getInitialProps

export default TransactionSellerId
